import { getCurrentAppByHostname } from '../../Helpers';

export const PortalView = () => {
  const appName = getCurrentAppByHostname();
  window.location.replace(
    `${
      appName === 'cc'
        ? process.env.REACT_APP_CC_PORTAL_URL
        : process.env.REACT_APP_NEXUS_PORTAL_URL
    }`
  );
  return null;
};
